export default __webpack_public_path__ + "static/media/icon_link.f517e49c.svg";